import { ProviderName } from 'v2/constants';
import { Nullable } from 'v2/types';

export enum ProviderTransactionActionType {
  BET = 'bet',
  WIN = 'win',
  ROLLBACK = 'rollback',
  PROMO_WIN = 'promoWin',
  BALANCE_INCREASE = 'balanceIncrease',
  END_ROUND = 'endRound',
  CLOSE_MATCH = 'closeMatch',
}

export interface ProviderTransaction {
  id: string;
  actionId: string;
  actionType: string;
  amount?: number;
  canceled: boolean;
  balanceAfter: Nullable<number>;
  userId: string;
  balanceId: Nullable<string>;
  tournamentId: Nullable<string>;
  providerName: string;
  gameId: Nullable<string>;
  date: string;
}

export interface ProviderTransactionsPage {
  result: ProviderTransaction[];
  nextCursor: Nullable<string>;
}

export interface ProviderTransactionFilter {
  userId: string;
  tournamentId: string;
  providerName: ProviderName | '';
  gameId: string;
  actionType: string;
  dateFrom: string;
  dateTo: string;
}
